export function formatDecimal(
  value: number,
  decimalPlaces = 2,
  locale = 'pt-BR',
): string {
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(value);
}
